// extracted by mini-css-extract-plugin
export default {"collapse":"OnSiteChecking_collapse__T+TL3"};